import React, { ReactNode, useState, useEffect, useImperativeHandle, forwardRef } from 'react';
import { useInfoPopover } from '@hooks/info-popover/use-info-popover';
import InfoPopover from '@components/atoms/info-popover/info-popover';
import useHeroPdpStyles from '@hooks/hero-pdp/use-hero-pdp-styles';
import { useTranslation } from 'next-i18next';
import { AppCookies } from '@enums/cookies';

interface MmaoOnboardingTooltipProps {
  children: ReactNode;
}

export interface MmaoOnboardingTooltipRef {
  hideTooltip: () => void;
}

const MmaoOnboardingTooltip = forwardRef<MmaoOnboardingTooltipRef, MmaoOnboardingTooltipProps>(({ children }, ref) => {
  const { t } = useTranslation();
  const { handleTooltipDismiss, isTooltipEnabled } = useInfoPopover({
    cookieString: AppCookies.MMAO_ONBOARDING_TOOLTIP_SEEN,
    onlyForNewUsers: true,
  });

  const [shouldShow, setShouldShow] = useState(false);
  const { isHeroPdpStyles } = useHeroPdpStyles();

  useEffect(() => {
    setShouldShow(isTooltipEnabled);
  }, [isTooltipEnabled]);

  const hideTooltip = () => {
    setShouldShow(false);
    handleTooltipDismiss();
  };

  useImperativeHandle(ref, () => ({
    hideTooltip,
  }));

  return (
    <InfoPopover
      title={t('PRODUCT.DETAILS.CTA.NEGOCIATE_TOOLTIP_TITLE')}
      subtitle={t('PRODUCT.DETAILS.CTA.NEGOCIATE_TOOLTIP_SUBTITLE')}
      cta={{
        text: t('PRODUCT.DETAILS.CTA.NEGOCIATE_TOOLTIP_CTA'),
        onClick: hideTooltip,
      }}
      showCloseButton={false}
      dataCy="pdp_mmao_onboarding_tooltip"
      onClose={hideTooltip}
      isVisible={shouldShow}
      classNameModifier={isHeroPdpStyles ? 'recirculation' : ''}
    >
      {children}
    </InfoPopover>
  );
});

export default MmaoOnboardingTooltip;
